import { ApiBase } from "../../core/api-base";
import { z } from "zod";
import { UpdatePassword200Response, UpdatePasswordBody } from "../../api/generated/users.zod";

export type UserProfilePasswordUpdateRequest = z.infer<typeof UpdatePasswordBody>;
export type UserProfilePasswordUpdateResponse = z.infer<typeof UpdatePassword200Response>;

export class UserProfilePasswordApi extends ApiBase {
    public static updatePassword(apiUrl: string, payload: UserProfilePasswordUpdateRequest): Promise<Response> {
        return super.apiPut(apiUrl, payload);
    }
}
